// extracted by mini-css-extract-plugin
export default {"container":"sponsors_container__jg8mx","sponsors_card":"sponsors_sponsors_card__KGimw","placeholder":"sponsors_placeholder__mVErL"};